import { FC, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { CubeTransparentIcon } from '@heroicons/react/16/solid'

const Uncaptured: FC = (): ReactNode => {
    const { Form } = SideoverState()

    if (!Form.Clipboard) return (
        <div className='flex flex-col items-center justify-center pt-5 pb-6 text-center px-8'>
            <CubeTransparentIcon className='flex-shrink-0 w-7 h-7 text-[#EBEBEB]' />

            <p className='mb-2 text-sm text-[#EBEBEB] mt-4'>
                Paste component using <span className='mr-1 px-1.5 py-1 text-xs font-semibold text-[#EBEBEB] bg-[#424242] border border-[#424242] rounded-md'>⌘</span> and <span className='ml-1 px-[7px] py-1 text-xs font-semibold text-[#EBEBEB] bg-[#424242] border border-[#424242] rounded-md'>V</span>
            </p>

            <p className='text-xs text-[#9a9d9e] -mt-.5'>
                Copy any webflow Component, and press the given keystrokes anywhere on the tab to paste.
            </p>
        </div>
    )
}

export default Uncaptured
